/**
 * Created by sswaminathan on 1/24/22
 * File: WorkFlowCard
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */

const WorkFlowCard = ({ Icon, content }) => {

  return (
    <div className={'tw-flex tw-flex-col tw-items-center tw-justify-center'}>
      <div className="tw-rounded-full tw-h-16 tw-w-16 tw-flex tw-bg-blue-200 tw-items-center tw-justify-center">
        <Icon size='sm' className="tw-text-gray-600" />
      </div>
      <div className="tw-flex tw-flex-row tw-justify-center tw-items-center">
        <Body addClassName="tw-pt-2 tw-text-gray-600 tw-text-center" appearance="primary" size="sm">{content.split(' ')[0]} <br/> {content.split(' ')[1]} </Body>
      </div>
    </div>
  )
}

WorkFlowCard.propTypes = {}
export default WorkFlowCard
